document.addEventListener('DOMContentLoaded', function(event) {
  document.getElementById('idp-login').submit();
});
